import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const deleteEvent = async ({ routeParams: { id } }: RouteParamsRequest<{ id: string }>) =>
  apiClient.delete<unknown, ApiClientResponse<unknown>>(routes.events.delete(id));
